module.exports = __webpack_public_path__ + "img/GOOD_CASPER.5cfe6cbf.png";